// Circular + breakdown match score visualization
export function MatchScore({ score, size = 72 }) {
  const r = size / 2 - 5;
  const c = 2 * Math.PI * r;
  const offset = c - (score / 100) * c;
  const color = score >= 85 ? "#002FA7" : score >= 70 ? "#0A0A0A" : "#9CA3AF";
  return (
    <div className="relative" style={{ width: size, height: size }} data-testid="match-score-ring">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} stroke="#E5E7EB" strokeWidth="5" fill="none" />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          stroke={color}
          strokeWidth="5"
          fill="none"
          strokeDasharray={c}
          strokeDashoffset={offset}
          strokeLinecap="butt"
        />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center">
        <span className="font-mono2 font-bold" style={{ color, fontSize: size / 4 }}>
          {score}%
        </span>
      </div>
    </div>
  );
}

const LABELS = {
  skill: "Skill",
  experience: "Experience",
  industry: "Industry",
  location: "Location",
  salary: "Salary",
  education: "Education",
  culture: "Culture",
};
const MAX = { skill: 35, experience: 25, industry: 15, location: 10, salary: 5, education: 5, culture: 5 };

export function MatchBreakdown({ breakdown }) {
  return (
    <div className="space-y-2" data-testid="match-breakdown">
      {Object.keys(MAX).map((k) => {
        const val = breakdown[k] || 0;
        const pct = (val / MAX[k]) * 100;
        return (
          <div key={k} className="flex items-center gap-3">
            <span className="w-24 text-xs font-medium text-[#4B5563]">{LABELS[k]}</span>
            <div className="flex-1 h-2 bg-[#F3F4F6]">
              <div className="h-2 bg-[#002FA7]" style={{ width: `${pct}%` }} />
            </div>
            <span className="font-mono2 text-xs font-bold w-12 text-right">
              {val}/{MAX[k]}
            </span>
          </div>
        );
      })}
    </div>
  );
}
